/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="8"
        height="8"
        viewBox="0 0 8 8"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          d="M3.99 0a4 4 0 1 1-4 4 4 4 0 0 1 4-4ZM.87 4a3.13 3.13 0 0 0 3.12 3.13 3.18 3.18 0 0 0 1.89-.63L4.77 5.39l-1.6-1.61L1.5 2.12A3.06 3.06 0 0 0 .87 4ZM4 .87a3.06 3.06 0 0 0-1.88.63l1 .95 1.61 1.61 1.81 1.82a3.12 3.12 0 0 0-2.49-5Z"
          className="icon-fill"/>
      </svg>
    );
  }
}

Icon.displayName = 'CircleWithDiagonalLineIcon';

export default Icon;
